import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Keyboard, View, ViewStyle } from 'react-native'

import { color, spacing } from '../../theme'
import { Button } from '../button'
import { TextInput } from '../text-input/text-input'
import { TextInputBubbleProps } from './text-input-bubble.props'
import { useTranslation } from 'react-i18next'
const STYLE = {
  borderRadius: 30,
  backgroundColor: color.palette.wildSand,
  paddingLeft: spacing[3],
  paddingRight: 55,
  paddingVertical: spacing[2],
  width: '100%',
} as ViewStyle

export function TextInputBubble(props: TextInputBubbleProps) {
  const {
    placeholder,
    placeholderTx,
    style,
    onPost,
    defaultValue,
    adjustPadding,
    buttonStyle,
    ...rest
  } = props

  const [comment, setComment] = useState('')

  const { t } = useTranslation()
  const i18nPlaceholderText = placeholderTx && t(placeholderTx)
  const placeholderContent = i18nPlaceholderText || placeholder

  const onSubmit = () => {
    onPost({ text: comment })
    setComment('')
    Keyboard.dismiss()
  }

  const postButtonStyle: ViewStyle = {
    position: 'absolute',
    alignSelf: 'center',
    right: spacing[3],
    bottom: 10,
    ...buttonStyle,
  }

  return (
    <View style={style}>
      <View style={STYLE}>
        <TextInput
          multiline
          // @ts-ignore
          dataSet={{ qat: 'comment_input' }}
          inputStyle={{
            width: '100%',
            borderBottomWidth: 0,
            paddingTop: 0,
            paddingBottom: 0,
            height: 20,
          }}
          placeholder={placeholderContent}
          onChangeText={(text) => setComment(text)}
          value={comment}
          allowExtendArea
        />
      </View>
      <Button
        tx="Discuss.post"
        dataSet={{ qat: 'post_btn' }}
        disabled={!comment?.trim()?.length}
        variant="text"
        style={postButtonStyle}
        textStyle={{ color: color.palette.blueLink }}
        onPress={onSubmit}
      />
    </View>
  )
}
